import { useEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import KitDetailDialogV3 from '@/pages/orderServiceSpaceChoose/components/KitDetailDialogV3'
import ModifyStandard from '@/pages/orderServiceSpaceChoose/components/ModifyStandard'
import SkuDynamicContent from '@/pages/orderServiceSpaceChoose/components/SkuDynamicContent'
import { listProductSkuRelationSpuFormat } from '@/services/order'
import { cloneDeep, isEmpty } from 'lodash-es'
import { useParams } from 'react-router-dom'

export default function ProductDeatail(props: any) {
  const {
    record,
    setCombinationPrice,
    modifyCurrentSku,
    setModifyCurrentSku,
    setMaterialDynaOptions,
    type,
    generalId,
    confirmInfo,
    combinationRef,
    modifyMode,
    setLoading,
  } = props
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  const [productInfo, setProductInfo] = useState<any>({})
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false)
  const [skuDynamicContentOpen, setSkuDynamicContentOpen] = useState(false)
  const kitDetailRef = useRef<any>(null)
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [packDtlList, setPackDtlList] = useState<any[]>([])
  const [skuDynamicVoList, setSkuDynamicVoList] = useState<any>([]) // 报价属性表单数据
  const [recordInfo, setRecordInfo] = useState<any>({})
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  const { budgetId } = useParams() // 报价id

  // 修改产品规格
  const handleEditDynamicProperties = async (record: any, index?: any) => {
    setModifyStandardOpen(true)
    setLoading(true)
    // setCurrentIndex(index)
    let dynaOptions
    let resData
    try {
      resData = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          productSpuId: modifyMode === 'edit' ? record?.prdId : record.productSpuId,
          generalId:
            record?.type === 'UP_DOWN' || record?.type === 'GENERAL'
              ? modifyMode === 'edit'
                ? record?.generalItemManageId  || record?.refGeneralItemManageId || null
                : record?.generalId || null
              : null,
          priceCalcType: record?.type === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId:
            modifyMode === 'edit'
              ? record?.refActiveDtlId || null
              : record?.activityProduct?.id || null,
          budgetDtlId: record.id,
        },
      })
    } catch {
      setLoading(false)
    }
    setLoading(false)
    dynaOptions = record.dynaOptions
    setSkuList(resData.skuList)
    resData.specificationArgList?.map((item: any) => {
      if (!isEmpty(dynaOptions)) {
        item.argValId = dynaOptions[item.argCode].valueId
        item.argValName = dynaOptions[item.argCode].valueName
      }
      item.options = item?.values.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    setCurrentModifyStandardArray(resData.specificationArgList || [])
  }

  useEffect(() => {
    if (record) {
      console.log(record, 'record')
      let newProductInfo = cloneDeep(record)
      // 如果有套件明细数据，过滤调不显示的数据 然后显示
      if (
        newProductInfo.productSpu?.combinationInfo?.length > 1 ||
        (modifyMode === 'edit' && newProductInfo?.packDtlList?.length > 0)
      ) {
        if (modifyMode !== 'edit') {
          newProductInfo.productSpu.combinationInfo =
            newProductInfo.productSpu?.combinationInfo.filter(item => item.allowView)
        }
        // 打开套件明细弹窗
        handleKitDetail(newProductInfo)
      }
      if (
        newProductInfo.productSpu?.skuSize > 0 ||
        (modifyMode === 'edit' && !isEmpty(newProductInfo?.dynaOptions))
      ) {
        // 多规格
        handleEditDynamicProperties(newProductInfo)
      }
      if (
        newProductInfo.skuDynamicVoList?.length ||
        (modifyMode === 'edit' && newProductInfo?.materialDynaOptions?.length)
      ) {
        // 报价属性
        // setSkuDynamicContentOpen(true)
        handleEditSkuDynamicVoList(newProductInfo)
      }
      setProductInfo({ ...newProductInfo })
    }
  }, [record])
  // 处理组合
  const handleKitDetail = async (record: any) => {
    setOpenKitDialog(true)
    //

    if (modifyMode === 'edit') {
      console.log('编辑组合')
      setLoading(true)
      // setRecordItem(item)
      setRecordInfo(record)
      setKitSku({})
      setKitSpu({})
      try {
        let resData: any = await listProductSkuRelationSpuFormat({
          data: {
            quoteBudgetId: budgetId,
            budgetDtlId: record.id,
            productSkuId: record.prdSkuId,
            productSpuId: record.prdId,
            generalId:
              record?.type === 'UP_DOWN' || record?.type === 'GENERAL'
                ? record?.generalItemManageId || record?.refGeneralItemManageId || null
                : null,
            priceCalcType: record?.type === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
            activityProductId: record?.refActiveDtlId || null,
          },
        })
        let skuInfo = resData?.skuList?.find(el => el.id === record.prdSkuId) || []
        setKitSku(skuInfo)
        setKitSpu(resData)
        if (record?.type === 'ACTIVITY') {
          setActivityInfo({
            activityId: record.refActiveId,
            activityProductId: record.refActiveDtlId,
          })
        }
        setPackDtlList(record.packDtlList || [])
        // setLoading(false)
      } catch (error) {
        // setLoading(false)
      }
    } else {
      if (record?.packDtlList) {
        // 批量选择时
        // 二次点开回显
        console.log(record, 'record')
        setKitSku(record.productSku)
        setKitSpu(record.productSpu)
        setCombinationInfoList(record?.packDtlList)
        if (type === 'ACTIVITY') {
          setActivityInfo({
            activityId: record.activity?.id,
            activityProductId: record.activityProduct?.id,
          })
        }
      } else {
        setKitSku(record?.productSpu?.skuList?.[0])
        setKitSpu(record?.productSpu)
        setLoading(false)
      }
    }
  }
  // 处理报价属性
  const handleEditSkuDynamicVoList = (record: any) => {
    setSkuDynamicContentOpen(true)
    if (modifyMode === 'edit') {
      let skuDynamicVoList = record.skuDynamicVoList.map(el => {
        let materialDynaOptions =
          record.materialDynaOptions?.find(item => item.id === el.id) || null
        if (materialDynaOptions) {
          el.optionId = materialDynaOptions.optionId
          el.optionName = materialDynaOptions.optionName
        }
        return el
      })
      // setRecordItem(item)
      setSkuDynamicVoList(skuDynamicVoList)
    } else {
      // 批量选择时
      // 二次点开回显
      if (record?.materialDynaOptions) {
        setSkuDynamicVoList(record?.materialDynaOptions)
      } else {
        setSkuDynamicVoList(record?.skuDynamicVoList)
      }
    }
  }
  return (
    <div className={styles.productDeatailBox}>
      {openKitDialog && (
        <KitDetailDialogV3
          kitSku={kitSku}
          setKitSku={setKitSku}
          setCombinationPrice={setCombinationPrice}
          productInfo={kitSpu}
          combinationInfoList={combinationInfoList}
          activityInfo={activityInfo}
          checkType="RightConfigArea"
          ref={kitDetailRef}
          budgetId={budgetId}
          type={type}
          generalId={generalId}
          confirmInfo={confirmInfo}
          packDtlList={packDtlList}
          setLoading={setLoading}
          recordInfo={recordInfo}
        />
      )}
      {/* 修改规格 */}
      {modifyStandardOpen && (
        <ModifyStandard
          formList={currentModifyStandardArray}
          currentSku={modifyCurrentSku}
          setCurrentSku={setModifyCurrentSku}
          skuList={skuList}
        ></ModifyStandard>
      )}
      {/* 动态属性 */}
      {skuDynamicContentOpen && (
        <SkuDynamicContent
          loading={false}
          formList={skuDynamicVoList}
          setMaterialDynaOptions={setMaterialDynaOptions}
          // onSubmit={onSubmitSkuDynamicVoList}
          // currentItem={kit}
        ></SkuDynamicContent>
      )}
    </div>
  )
}
